import { Box, ButtonNew, Icon, IconIds, IconOptions, ModalDialog, Spacer, TextNew } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { FC, useState } from 'react'
import { Platform } from 'react-native'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { fieldSettingsFilterStrings, staticStrings } from '../../data/static/strings'
import { TransactionsType } from '../../screens/TransactionNew/types'
import { Colors, useWindowDimensions } from '../../util/util'
import styles from './FilterStyles'

interface FieldSettingsFilterMenuProps {
  hide?: boolean
  setFieldSettingVisible: (data: boolean) => void
  fieldSettingVisible: boolean
  setFilterVisible: (data: boolean) => void
  filterVisible: boolean
  hideFieldSettings?: boolean
  path?: any
  subscriptionFiltersCount?: any
  clearSubscriptionFilters: () => void
  isFiltersApplied: boolean
  isTransactionFilterApplied: boolean
  returnTransactionFilterCount: () => void
  returnPaymentLinkFilterCount: () => void
  paymentLinkFilterApplied: boolean
  returnBeneficiaryFilterCount: any
}

interface modalListProps {
  toggleFilterSettings: () => void
  toggleFieldSettings: () => void
  handleCancel: () => void
}

const ModalList: FC<modalListProps> = ({ toggleFilterSettings, toggleFieldSettings, handleCancel }: modalListProps) => {
  return (
    <Box {...styles.modalList}>
      <Box onPress={toggleFieldSettings} testID="toggle-field-settings" {...styles.modalListItem}>
        <Icon size={14} color={'BLACK_21'} id={IconIds.SETTING as IconOptions} />
        <Spacer size={16} direction="horizontal" />
        <TextNew type={'body14'} fontWeight="MEDIUM">
          {fieldSettingsFilterStrings.labelFieldSettings}
        </TextNew>
      </Box>
      <Box onPress={toggleFilterSettings} testID="toggle-filter-settings" {...styles.modalListItem}>
        <Icon size={14} color={'BLACK_21'} id={IconIds.FILTER as IconOptions} />
        <Spacer size={16} direction="horizontal" />
        <TextNew type={'body14'} fontWeight="MEDIUM">
          {fieldSettingsFilterStrings.labelFilters}
        </TextNew>
      </Box>
      <Box {...styles.buttonContainer}>
        {/* <Button
          size={ButtonSize.MOBILE_SIZE}
          onPress={handleCancel}
          type={ButtonTypes.ICON_LH}
          color={'transparent'}
          textColor={defaultColors.BLUE}>
          {staticStrings.cancel}
        </Button> */}
        <ButtonNew
          testID="cancel-field-settings"
          onPress={handleCancel}
          title={staticStrings.cancel}
          type={'custom'}
          textType={'body12'}
          borderWidth={'0.5px'}
          color={'transparent'}
          borderRadius={'5px'}
          hoverColor={'BRAND_COLOR_GRAY_6'}
          underlayColor={'BRAND_COLOR_GRAY_5'}
          titleColor={defaultColors.BLUE}
        />
      </Box>
    </Box>
  )
}

const FieldSettingsFilterMenu: FC<FieldSettingsFilterMenuProps> = ({
  hide = false,
  setFieldSettingVisible,
  fieldSettingVisible,
  setFilterVisible,
  filterVisible,
  hideFieldSettings,
  path,
  subscriptionFiltersCount,
  // clearSubscriptionFilters,
  isFiltersApplied,
  isTransactionFilterApplied,
  returnTransactionFilterCount,
  returnPaymentLinkFilterCount,
  paymentLinkFilterApplied,
  returnBeneficiaryFilterCount,
}: FieldSettingsFilterMenuProps) => {
  const [menuVisible, setMenuVisible] = useState(false)
  const window = {
    width: useWindowDimensions(),
  }

  const isMobile = window?.width < 560 && Platform.OS !== 'web'

  if (hide) {
    return null
  }

  const getCount = () => {
    const linkFilterCount = `(${returnPaymentLinkFilterCount})`
    console.log('isApplied', paymentLinkFilterApplied)
    console.log('returnPaymentLinkFilterCount', returnPaymentLinkFilterCount)
    const beneficiaryFilterCount = `(${returnBeneficiaryFilterCount()?.count})`

    if (path === TransactionsType.subscriptions && subscriptionFiltersCount !== 0 && isFiltersApplied) {
      return `(${subscriptionFiltersCount})`
    } else if (path === TransactionsType.transactions && isTransactionFilterApplied) {
      return `(${returnTransactionFilterCount})`
    } else if (path === TransactionsType.paymentlinks && paymentLinkFilterApplied) {
      return linkFilterCount
    } else if (path === TransactionsType.payoutsbeneficiary && returnBeneficiaryFilterCount()?.isApplied) {
      return beneficiaryFilterCount
    } else {
      return ''
    }
  }

  const toggleFieldSettings = (): void => {
    if (filterVisible) {
      setFilterVisible(!filterVisible)
    }
    setFieldSettingVisible(!fieldSettingVisible)
    setMenuVisible(false)
  }

  const toggleFilterSettings = (): void => {
    if (fieldSettingVisible) {
      setFieldSettingVisible(!fieldSettingVisible)
    }
    setFilterVisible(!filterVisible)
    setMenuVisible(false)
  }

  const handlePress = (): void => {
    setMenuVisible(!menuVisible)
  }

  const handleCancel = (): void => {
    setFieldSettingVisible(false)
    setFilterVisible(false)
    setMenuVisible(false)
  }

  // const clearFilters = () => {
  //   clearSubscriptionFilters()
  // }

  // const getClearIcon = () => {
  //   if (path === TransactionsType.subscriptions && subscriptionFiltersCount !== 0 && isFiltersApplied) {
  //     return (
  //       <Box onPress={clearFilters} underlayColor="TRANSPARENT">
  //         <Icon id={IconIds.CLEAR as IconOptions} color={'BLACK_75'} size={15} />
  //       </Box>
  //     )
  //   }
  //   return undefined
  // }

  return (
    <>
      <ModalDialog
        children={
          <ModalList
            handleCancel={handleCancel}
            toggleFieldSettings={toggleFieldSettings}
            toggleFilterSettings={toggleFilterSettings}
          />
        }
        show={menuVisible}
        // type={ModalTypes.MODAL_BOTTOM}
        type={'Bottom'}
        // embedInScrollView={false}
        onDismiss={handleCancel}
      />
      <Spacer size={10} direction="horizontal" />
      <Spacer size={10} />
      <ButtonNew
        testID="toggle-field-settings-btn"
        onPress={toggleFieldSettings}
        title={fieldSettingsFilterStrings.labelFieldSettings}
        hide={isMobile || hideFieldSettings}
        type={'custom'}
        textType={'body12'}
        borderWidth={'0.5px'}
        color={fieldSettingVisible ? Colors.BLUE_0A : defaultColors.WHITE}
        borderColor={fieldSettingVisible ? Colors.BLUE_80 : defaultColors.DISABLED_GREY}
        borderRadius={'5px'}
        hoverColor={'BRAND_COLOR_GRAY_6'}
        underlayColor={'BRAND_COLOR_GRAY_5'}
        icon={'SETTING'}
        titleColor={'BLACK'}
      />
      <Spacer size={10} direction="horizontal" hide={isMobile} />
      <Spacer size={10} hide={isMobile} />
      <ButtonNew
        testID="toggle-filter-settings-btn"
        onPress={toggleFilterSettings}
        title={`${fieldSettingsFilterStrings.labelFilters}${getCount()}`}
        hide={isMobile}
        type={'custom'}
        textType={'body12'}
        borderWidth={'0.5px'}
        borderColor={filterVisible ? Colors.BLUE_80 : defaultColors.DISABLED_GREY}
        color={filterVisible ? Colors.BLUE_0A : defaultColors.WHITE}
        borderRadius={'5px'}
        hoverColor={'BRAND_COLOR_GRAY_6'}
        underlayColor={'BRAND_COLOR_GRAY_5'}
        icon={'FILTER'}
        titleColor={'BLACK'}
        enableDot={getCount() ? true : false}
      />

      <ModBox show={isMobile}>
        <Box {...styles.bars} onPress={handlePress} testID="toggle-options">
          <Icon color={'BLACK_21'} id={IconIds.OPTIONS as IconOptions} />
        </Box>
      </ModBox>
    </>
  )
}

export default FieldSettingsFilterMenu
